export enum ProjectTaskDialogPanels {
  // NEW PANELS
  NewBasicInfo = 'newBasicInfo',
  NewTriggers = 'newTriggers',
  NewSchedule = 'newSchedule',
  NewSubtasks = 'newSubtasks',
  NewSuccess = 'newSuccess',
  NewCancel = 'newCancel',

  // SHARED PANELS
  Assignments = 'assignments',
  DateTimePicker = 'dateTimePicker',
  SubtaskList = 'subtaskList',
  NewTracker = 'newTracker',
  DeleteTaskConfirmation = 'deleteTaskConfirmation',
  DeleteTemplateConfirmation = 'deleteTemplateConfirmation',
  IconPicker = 'iconPicker',
  Requirements = 'requirements',
  PeopleTeamsSelection = 'peopleTeamsSelection',

  // EDIT PANELS
  Default = 'default',
  SubtaskEdit = 'subtaskEdit',
}

export enum ProjectTaskDialogTabs {
  Details = 'details',
  Schedule = 'schedule',
  Triggers = 'triggers',
  Subtasks = 'subtasks',
}

export const NEW_PROJECT_TASK_DIALOG_SETTINGS = {
  maxHeight: '90vh',
  height: '705px',
  panelClass: 'task-dialog',
  disableClose: true,
};

export const EDIT_PROJECT_TASK_DIALOG_SETTINGS = {
  maxHeight: '90vh',
  height: '730px',
  panelClass: 'task-dialog',
  disableClose: true,
};
